/** 관리자 로고·이미지 설정 localStorage 키 (MainLayout, AdminLogin, OtpPage에서 사용) */
export const ADMIN_LOGIN_LOGO_KEY = 'admin_login_logo';
export const ADMIN_LOGIN_BG_KEY = 'admin_login_bg';
export const ADMIN_HEADER_LOGO_KEY = 'admin_header_logo';

export const DEFAULT_ADMIN_LOGIN_LOGO = '/img/logo_2.png';
export const DEFAULT_ADMIN_LOGIN_BG = '/img/login_bg_img.png';

/** 기본에는 이미지 없음. 관리자가 업로드·설정한 경우에만 표시 */
export function getAdminLoginLogo() {
  if (typeof window === 'undefined') return '';
  return localStorage.getItem(ADMIN_LOGIN_LOGO_KEY) || '';
}

export function getAdminLoginBg() {
  if (typeof window === 'undefined') return '';
  return localStorage.getItem(ADMIN_LOGIN_BG_KEY) || '';
}

/** 업로드 성공 시 설정 → 이미지 URL에 ?t= 붙여 캐시 무효화 */
export const SITE_ASSETS_VERSION_KEY = 'site_assets_version';

const LOGIN_LOGO_OVERRIDE = (process.env.REACT_APP_LOGIN_LOGO_URL || '').trim();
const HEADER_LOGO_OVERRIDE = (process.env.REACT_APP_HEADER_LOGO_URL || '').trim();
const APP_LOGO_OVERRIDE = (process.env.REACT_APP_APP_LOGO_URL || '').trim();
const APP_LOGO_FALLBACK_OVERRIDE = (process.env.REACT_APP_APP_LOGO_FALLBACK_URL || '').trim();
const LOGIN_LOGO_HEIGHT = (process.env.REACT_APP_LOGIN_LOGO_HEIGHT || '').trim();
const OTP_LOGO_HEIGHT = (process.env.REACT_APP_OTP_LOGO_HEIGHT || '').trim();
const HEADER_LOGO_HEIGHT = (process.env.REACT_APP_HEADER_LOGO_HEIGHT || '').trim();
const HEADER_LOGO_MAX_HEIGHT = (process.env.REACT_APP_HEADER_LOGO_MAX_HEIGHT || '').trim();
const APP_LOGO_WIDTH = (process.env.REACT_APP_APP_LOGO_WIDTH || '').trim();
const APP_LOGO_HEIGHT = (process.env.REACT_APP_APP_LOGO_HEIGHT || '').trim();
const APP_LOGIN_LOGO_WIDTH = (process.env.REACT_APP_APP_LOGIN_LOGO_WIDTH || '').trim();
const APP_LOGIN_LOGO_HEIGHT = (process.env.REACT_APP_APP_LOGIN_LOGO_HEIGHT || '').trim();
const APP_HEADER_LOGO_WIDTH = (process.env.REACT_APP_APP_HEADER_LOGO_WIDTH || '').trim();
const APP_HEADER_LOGO_HEIGHT = (process.env.REACT_APP_APP_HEADER_LOGO_HEIGHT || '').trim();

function appendCacheBust(url) {
  if (typeof window === 'undefined' || !url) return url;
  const v = localStorage.getItem(SITE_ASSETS_VERSION_KEY);
  return v ? `${url}${url.includes('?') ? '&' : '?'}t=${v}` : url;
}

/** 로그인 배경 이미지 고정 경로: REACT_APP_API/public/site-assets/login-background.png */
export function getLoginBackgroundAssetUrl() {
  const base = (typeof window !== 'undefined' ? process.env.REACT_APP_API : '') || '';
  const path = '/public/site-assets/login-background.png';
  const url = base ? `${base.replace(/\/$/, '')}${path}` : path;
  return appendCacheBust(url);
}

/** 로그인 로고 이미지 고정 경로: REACT_APP_API/public/site-assets/login-logo.png */
export function getLoginLogoAssetUrl() {
  if (LOGIN_LOGO_OVERRIDE) return appendCacheBust(LOGIN_LOGO_OVERRIDE);
  const base = (typeof window !== 'undefined' ? process.env.REACT_APP_API : '') || '';
  const path = '/public/site-assets/login-logo.png';
  const url = base ? `${base.replace(/\/$/, '')}${path}` : path;
  return appendCacheBust(url);
}

/** 헤더 로고 이미지 고정 경로: REACT_APP_API/public/site-assets/header-logo.png */
export function getHeaderLogoAssetUrl() {
  if (HEADER_LOGO_OVERRIDE) return appendCacheBust(HEADER_LOGO_OVERRIDE);
  const base = (typeof window !== 'undefined' ? process.env.REACT_APP_API : '') || '';
  const path = '/public/site-assets/header-logo.png';
  const url = base ? `${base.replace(/\/$/, '')}${path}` : path;
  return appendCacheBust(url);
}

export function getAppLogoAssetUrl() {
  return APP_LOGO_OVERRIDE || '/img/logo_5.png';
}

export function getAppLogoFallbackUrl() {
  return APP_LOGO_FALLBACK_OVERRIDE || '/img/logo_3.PNG';
}

export function getLoginLogoStyle(extraStyle = {}) {
  return {
    width: 'auto',
    height: LOGIN_LOGO_HEIGHT || '50px',
    ...extraStyle,
    ...(LOGIN_LOGO_HEIGHT ? { height: LOGIN_LOGO_HEIGHT } : {}),
  };
}

export function getOtpLogoStyle(extraStyle = {}) {
  const height = OTP_LOGO_HEIGHT || LOGIN_LOGO_HEIGHT || '60px';
  return {
    width: 'auto',
    height,
    ...extraStyle,
    ...(OTP_LOGO_HEIGHT ? { height: OTP_LOGO_HEIGHT } : {}),
  };
}

export function getHeaderLogoStyle(extraStyle = {}) {
  return {
    width: 'auto',
    maxHeight: HEADER_LOGO_MAX_HEIGHT || '48px',
    height: HEADER_LOGO_HEIGHT || '23px',
    ...extraStyle,
    ...(HEADER_LOGO_MAX_HEIGHT ? { maxHeight: HEADER_LOGO_MAX_HEIGHT } : {}),
    ...(HEADER_LOGO_HEIGHT ? { height: HEADER_LOGO_HEIGHT } : {}),
  };
}

export function getAppLoginLogoStyle(extraStyle = {}) {
  const width = APP_LOGIN_LOGO_WIDTH || APP_LOGO_WIDTH || extraStyle.width || '140px';
  const height = APP_LOGIN_LOGO_HEIGHT || APP_LOGO_HEIGHT || extraStyle.height || 'auto';
  return {
    ...extraStyle,
    width,
    height,
  };
}

export function getTerminalHeaderStyle() {
  if (String(process.env.REACT_APP_TERMINAL_HEADER_THEME || '').trim().toLowerCase() !== 'light') return {};
  return {
    background: '#F8FAFC',
    borderBottom: '1px solid #E2E8F0',
    '--terminal-header-foreground': '#17324D',
    '--terminal-header-button-border': '#CBD5E1',
  };
}

export function getAppHeaderLogoStyle(extraStyle = {}) {
  const width = APP_HEADER_LOGO_WIDTH || APP_LOGO_WIDTH || extraStyle.width || '150px';
  const height = APP_HEADER_LOGO_HEIGHT || APP_LOGO_HEIGHT || extraStyle.height || 'auto';
  return {
    ...extraStyle,
    width,
    height,
    ...(String(process.env.REACT_APP_TERMINAL_HEADER_THEME || '').trim().toLowerCase() !== 'light' && String(process.env.REACT_APP_TERMINAL_HEADER_LOGO_BACKGROUND || '').trim().toLowerCase() === 'white'
      ? {
          backgroundColor: '#FFFFFF',
          padding: '6px 10px',
          borderRadius: '8px',
          boxSizing: 'border-box',
          objectFit: 'contain',
          maxHeight: '42px',
          maxWidth: 'calc(100% - 160px)',
        }
      : {}),
  };
}
